import {log} from '@/model/logger';

export function initializeReCaptcha() {
    const googleReCaptcha = (window as any).grecaptcha || null;

    if (googleReCaptcha == null) {
        return;
    }

    let init = false;
    const recaptcha = () => {
        const items = document.querySelectorAll<HTMLInputElement>('.g-recaptcha');
        const length = items.length;

        if (length > 0) {
            googleReCaptcha.ready(() => {
                for (let i = 0; i < length; i++) {
                    log('Initialized ReCaptcha for element', items[i]);
                    googleReCaptcha.render(items[i]);
                }
                googleReCaptcha.execute().then((token: string) => {
                    const inputs = document.querySelectorAll<HTMLInputElement>('.g-recaptcha-response');

                    for (let i = 0; i < items.length; i++) {
                        log('Saved ReCaptcha response for element', inputs[i]);
                        inputs[i].value = token;
                    }
                });
            });

            init = true;
        }
    };

    if (!init) {
        recaptcha();
    }
}
